import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Heart, Plus, ShoppingCart } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard, GradButton, fmtMoney } from "@/components/erp";
import { UrunGorsel } from "@/components/UrunGorsel";
import api, { errMsg } from "@/lib/api";

export const favoriDegistir = async (u, acik) => {
  try {
    if (acik) await api.post(`/bayi/favoriler/${u.id}`); else await api.delete(`/bayi/favoriler/${u.id}`);
    toast.success(acik ? `${u.kod} favorilere eklendi` : `${u.kod} favorilerden çıkarıldı`);
    return true;
  } catch (e) { toast.error(errMsg(e)); return false; }
};

const Satir = ({ u, pb, m, setM, onEkle, onFavori, alt }) => (
  <div className="flex flex-wrap items-center gap-3 py-3 border-b border-white/5" data-testid={`fav-satir-${u.kod}`}>
    <UrunGorsel id={u.id} var={u.gorsel} className="w-12 h-12" />
    <div className="min-w-0 flex-1 basis-40">
      <div className="font-mono text-[11px] text-muted-foreground">{u.kod}</div>
      <div className="text-sm truncate">{u.ad}</div>
      <div className="text-xs text-muted-foreground">{u.stok > 0 ? `Stok: ${u.stok}` : "Stokta yok · üretimden"}{alt ? ` · ${alt}` : ""}</div>
    </div>
    <div className="flex items-center gap-2 ml-auto">
    <span className="font-mono text-sm w-24 text-right">{u.kampanya && <span className="block text-[10px] text-rose-300">%{u.kampanya.yuzde} kampanya</span>}{u.fiyat == null ? "—" : fmtMoney(u.fiyat, pb)}</span>
    <Input type="number" min="0" value={m} onChange={(e) => setM(e.target.value)} className="h-8 w-20 bg-white/5" data-testid={`fav-miktar-${u.kod}`} />
    <button data-testid={`fav-ekle-${u.kod}`} disabled={u.fiyat == null || !(Number(m) > 0)} onClick={() => onEkle(u, Number(m))} className="p-2 rounded-full grad-bg text-white disabled:opacity-40"><Plus className="w-4 h-4" /></button>
    <button data-testid={`fav-kalp-${u.kod}`} onClick={() => onFavori(u)} title={u.favori ? "Favorilerden çıkar" : "Favorilere ekle"} className="p-2 rounded-full hover:bg-white/10">
      <Heart className={`w-4 h-4 ${u.favori ? "fill-rose-400 text-rose-400" : "text-muted-foreground"}`} /></button>
    </div>
  </div>
);

const Liste = ({ baslik, liste, pb, miktar, setMiktar, onEkle, onFavori, alt, testid }) => (
  <GlassCard className="p-5" data-testid={testid}>
    <div className="font-head font-semibold">{baslik}</div>
    {liste.map((u) => <Satir key={u.id} u={u} pb={pb} m={miktar[u.id] ?? ""} setM={(v) => setMiktar((s) => ({ ...s, [u.id]: v }))} onEkle={onEkle} onFavori={onFavori} alt={alt && alt(u)} />)}
  </GlassCard>
);

export const BayiFavoriler = ({ pb, onEkle }) => {
  const [d, setD] = useState(null);
  const [miktar, setMiktar] = useState({});
  const load = () => api.get("/bayi/favoriler").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const favori = async (u) => { if (await favoriDegistir(u, !u.favori)) load(); };
  const ekle = (u, m) => { onEkle(u, m); setMiktar((s) => ({ ...s, [u.id]: "" })); toast.success(`${u.kod} sepete eklendi`); };
  if (!d) return null;
  const hepsi = [...d.favoriler, ...d.sik].filter((u) => Number(miktar[u.id]) > 0 && u.fiyat != null);
  const topluEkle = () => { hepsi.forEach((u) => onEkle(u, Number(miktar[u.id]))); toast.success(`${hepsi.length} ürün sepete eklendi`); setMiktar({}); };
  return (
    <div className="space-y-4" data-testid="bayi-favoriler">
      <p className="text-sm text-muted-foreground">Miktarları yazın ve tek tek ya da hepsini birden sepete ekleyin. Ürünler sekmesindeki kalp ile favori ekleyebilirsiniz.</p>
      {d.favoriler.length === 0 && d.sik.length === 0 && <p className="text-sm text-muted-foreground py-6 text-center" data-testid="fav-bos">Henüz favori ürününüz yok.</p>}
      {d.favoriler.length > 0 && <Liste testid="fav-liste" baslik="Favorilerim" liste={d.favoriler} pb={pb} miktar={miktar} setMiktar={setMiktar} onEkle={ekle} onFavori={favori} />}
      {d.sik.length > 0 && <Liste testid="fav-sik" baslik="Sık aldıklarınız" liste={d.sik} pb={pb} miktar={miktar} setMiktar={setMiktar} onEkle={ekle} onFavori={favori}
        alt={(u) => `${u.siparis_sayisi} siparişte, toplam ${u.toplam_miktar}`} />}
      {hepsi.length > 0 && <GradButton data-testid="fav-toplu-ekle" onClick={topluEkle}><ShoppingCart className="w-4 h-4" />Miktar yazılan {hepsi.length} ürünü sepete ekle</GradButton>}
    </div>
  );
};
